import { render, staticRenderFns } from "./MatchingExpressionsPageSelector.vue?vue&type=template&id=022b6126&"
import script from "./MatchingExpressionsPageSelector.vue?vue&type=script&lang=js&"
export * from "./MatchingExpressionsPageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports